import {
    EDUCATION_DOCUMENTS,
    TYPES_EDUCATION_DOCUMENTS,
    SCHEMES_EDUCATION_DOCUMENTS,
    LOADING_EDUCATION_DOCUMENTS,
    LOADED_EDUCATION_DOCUMENTS,
} from '../store/actionTypes';

export const typesEducationDocuments = (state = [], action) => {
    switch (action.type) {
        case TYPES_EDUCATION_DOCUMENTS:
            return action.list;
        default:
            return state;
    }
};
export const schemesEducationDocuments = (state = {}, action) => {
    switch (action.type) {
        case SCHEMES_EDUCATION_DOCUMENTS:
            return action.object;
        default:
            return state;
    }
};
export const educationDocuments = (state = [], action) => {
    switch (action.type) {
        case EDUCATION_DOCUMENTS:
            return action.list;
        default:
            return state;
    }
};
export const loadingEducationDocuments = (state = false, action) => {
    switch (action.type) {
        case LOADING_EDUCATION_DOCUMENTS:
            return action.status;
        default:
            return state;
    }
};
export const loadedEducationDocuments = (state = false, action) => {
    switch (action.type) {
        case LOADED_EDUCATION_DOCUMENTS:
            return action.status;
        default:
            return state;
    }
};
